const steps = [
  'You tell us about your project.',
  'We reply within one business day with questions or a call.',
  'You receive a tailored proposal — no commitment.'
];

export default function NextSteps() {
  return (
    <section className="max-w-4xl mx-auto px-6 lg:px-8 mt-12">
      <h2 className="font-inter font-black text-2xl md:text-3xl text-foreground mb-6">What happens next</h2>
      <ol className="grid md:grid-cols-3 gap-4">
        {steps.map((s, i) => (
          <li key={s} className="rounded-2xl border border-border/50 bg-card/40 p-6">
            <span className="font-black text-2xl text-primary">{i + 1}</span>
            <p className="text-sm text-muted-foreground mt-2">{s}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}